module.exports = __webpack_public_path__ + "img/016.6dfe135e.png";